export default __webpack_public_path__ + "static/media/PA.a1eaeda1.svg";